export default __webpack_public_path__ + "static/media/수협.4a2599a6.svg";